import Immutable, { List, Record, Map } from 'immutable';

import traintime from '../lib/TrainTime';
import config from '../config';
import { unique } from '../helpers/Immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const BannerState = new Record({
    banner: null,
    dismissed: new List()
});

export class BannerStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.BANNER_CONFIG_LOADED]: this.handleBannerLoaded,
            [ActionTypes.BANNER_DISMISSED]: this.handleBannerDismissed
        };
    }

    deserialize (serialized) {
        if (serialized) {
            return new BannerState({ dismissed: Immutable.fromJS(serialized.dismissed) });
        }
        return new BannerState();
    }

    serialize () {
        const now = traintime();
        const notExpired = this.state.dismissed.filter(
            (dismissedBanner) => traintime(dismissedBanner.get('expiry')).isAfter(now)
        );
        const uniqueDismissed = unique(notExpired, (dismissedBanner) => dismissedBanner.get('id'));

        return {
            dismissed: uniqueDismissed.toJS()
        };
    }

    handleBannerLoaded ({ banner }) {
        this.setState(this.state.set('banner', banner));
    }

    handleBannerDismissed ({ id }) {
        const expires = config.get('bannerMessageDismissExpires') || false;
        const dismissedBanner = new Map({
            id,
            expiry: traintime().add(expires, 'seconds').format()
        });
        this.setState(
            this.state.set('dismissed', this.state.dismissed.push(dismissedBanner))
        );
    }

    isBannerDismissed (banner) {
        const dismissed = this.state.dismissed.findLast(
            (dismissedBanner) => dismissedBanner.get('id') === banner.id
        );
        if (dismissed) {
            return traintime(dismissed.get('expiry')).isAfter(traintime());
        }
        return false;
    }

    getActive () {
        const { banner } = this.state;
        if (banner && banner.isActive() && !this.isBannerDismissed(banner)) {
            return banner;
        }
        return null;
    }

}

const storeInstance = new BannerStore({ storageKey: 'banner' });

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/BannerStore.js